import { render, staticRenderFns } from "./PhoenixIncomeVerification.vue?vue&type=template&id=45e556fe"
import script from "./PhoenixIncomeVerification.vue?vue&type=script&lang=js"
export * from "./PhoenixIncomeVerification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports